import PriceList from './price-list';

export default PriceList;